export const SignUpType = {
  handleTextChange: "[SignUp] handleTextChange",
  handleSelectKit: "[SignUp] handleSelectKit",
  handleAddressesChange: "[SignUp] handleAddressesChange",
  error: "[SignUp] Error",
  clear: "[SignUp] clear",
};
